import {BehaviorSubject} from 'rxjs';
import {IDataTalentSkill} from "../_interfaces/IDataTalentSkill";

interface InfoTalentSkill {
    popOpen: boolean
    popEl: Element | HTMLElement | null
    pop: IDataTalentSkill | null
}

const InfoTalentSkillSubscriber = new BehaviorSubject<InfoTalentSkill>({popOpen: false, popEl: null, pop: null});

export {
    InfoTalentSkillSubscriber
}
